import { c as _c } from "react/compiler-runtime";
/**
 * @file resend-invite-modal.tsx
 * @description
 * -----------------------------------------------------
 * Modal para confirmar el reenvío de la invitación a un usuario
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-01
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

import ModalComponent from "@/components/modals/ModalComponent";
import { useTranslations } from "next-intl";
import { ColumnsAllUsers } from "@/types/commons/columns";
import { fetchResendInvite } from "..";
import { toast } from "sonner";
import { useTransition } from "react";
interface ResendInviteModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: ColumnsAllUsers;
  lastSentAt?: string;
}
const ResendInviteModal = t0 => {
  const $ = _c(29);
  const {
    isOpen,
    onClose,
    user,
    lastSentAt
  } = t0;
  const t = useTranslations("Modals.ResendInviteModal");
  const [isPending, startTransition] = useTransition();
  let t1;
  if ($[0] !== onClose || $[1] !== user) {
    t1 = async () => {
      startTransition(async () => {
        const response = await fetchResendInvite({
          mail: user.mail || user.email
        });
        if (response.error) {
          toast.error(response.message);
          return;
        }
        toast.success(response.message);
        onClose();
      });
    };
    $[0] = onClose;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleResend = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p>{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("lastSentLabel");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <dt>{t5}</dt>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== lastSentAt || $[14] !== t) {
    t7 = lastSentAt ? <time dateTime={lastSentAt}>{lastSentAt}</time> : t("noLastSent");
    $[13] = lastSentAt;
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <dd>{t7}</dd>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <dl className="resend-invite__last-sent">{t6}{t8}</dl>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== handleResend || $[22] !== isOpen || $[23] !== isPending || $[24] !== onClose || $[25] !== t2 || $[26] !== t4 || $[27] !== t9) {
    t10 = <ModalComponent title={t2} isOpen={isOpen} onClose={onClose} avoidCloseOnSubmit={true} buttonCancel={true} buttonCancelText="buttonCancel" buttonConfirmText="buttonResendInvite" onConfirm={handleResend} loadingConfirm={isPending}>{t4}{t9}</ModalComponent>;
    $[21] = handleResend;
    $[22] = isOpen;
    $[23] = isPending;
    $[24] = onClose;
    $[25] = t2;
    $[26] = t4;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default ResendInviteModal;